export function getLinePointsFromZoneCoordinates(zones = []) {
  return zones
    ?.map((zone) =>
      Array.isArray(zone?.zone_coordinates) &&
      zone?.zone_coordinates?.length > 0
        ? [...zone?.zone_coordinates, zone?.zone_coordinates[0]].map((zc) => [
            zc.x,
            zc.y,
          ])
        : []
    )
    .map((coords, index) => ({
      zoneId: zones[index]?.id,
      coordinates: coords?.flat(),
    }));
}

export function getZoneCentroidCircles(zones = []) {
  return zones?.map((zone) => {
    let points = [];
    if (
      Array.isArray(zone?.zone_coordinates) &&
      zone?.zone_coordinates?.length > 0
    ) {
      points = [
        ...zone?.zone_coordinates?.map((coord) => [coord?.x, coord?.y]),
        [zone?.zone_coordinates[0]?.x, zone?.zone_coordinates[0]?.y],
      ];
    }

    const x_coords = points.reduce((sum, [x, _]) => sum + x, 0);

    const y_coords = points.reduce((sum, [_, y]) => sum + y, 0);

    const centroid = {
      x: x_coords > 0 ? x_coords / points.length : null,
      y: y_coords > 0 ? y_coords / points.length : null,
    };
    return {
      ...zone,
      centroid,
    };
  });
}
